
import IndexModel from "@/service/v1/seguranca/IndexModel";
 
class UsuarioService extends IndexModel {
      
    constructor() {
        super();
        this.url = this.url + '/Usuario';
    }
 
    public getApiUrl() {
        return this.getAxios().defaults.baseURL + this.url;
    }
      
    public getModel(id) : Promise<any> {
        return new Promise((resolve, reject) => {
            this.getAxios().get(this.url + '/' + id)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response);
                })
        });
    }
    
    public removerPerfil( dados: any ) : Promise<any> {
        const header = { 'Content-Type': 'application/json'  }; 
        return new Promise((resolve, reject) => {
            this.getAxios().delete(this.url + "/Remove/Perfil" , {  data: dados } )
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response);
                })
        });
    }
   
    public adicionarPerfil(  dados: any ) : Promise<any> { 
        return  new Promise((resolve, reject) => {  
            this.getAxios().patch( this.url + "/Perfil" , dados    )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {   
                reject(error.response);
            }) 
        }); 
    }

    public meuProfile() : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url  + '/Profile'  )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
     
    public updateMy(   dados: any ) : Promise<any>  { 
        return  new Promise((resolve, reject) => {  
            this.getAxios().put( this.url + '/Profile'   , dados  )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {   
                reject(error.response);
            }) 
        }); 
    }
     
    public getRelatorioPagamentoInstrutor( cpf: any , dataAulaMin: any , dataAulaMax: any ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url  + `/Relatorio/Pagamento/Instrutor?cpf=${cpf}&dataAulaMin=${dataAulaMin}&dataAulaMax=${dataAulaMax}`  )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
 
    public getTodos(search) : Promise<any> {   
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url  + '?search=' + search  )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
     
    
    public updateRh( cpf: any  ) : Promise<any>  { 
        return  new Promise((resolve, reject) => {  
            this.getAxios().patch( this.url + '/Rh/' + cpf   )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {   
                reject(error.response);
            }) 
        }); 
    }
     
    
    public atualizarTodoAlunosRH( turmaId: any  ) : Promise<any>  { 
        return  new Promise((resolve, reject) => {  
            this.getAxios().patch( this.url + '/Rh?turmaId=' + turmaId   )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {   
                reject(error.response);
            }) 
        }); 
    }
    
    
    public atualizarTodoInstrutorRH( turmaId: any  ) : Promise<any>  { 
        return  new Promise((resolve, reject) => {  
            this.getAxios().patch( this.url + '/Rh?instrutorTurmaId=' + turmaId   )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {   
                reject(error.response);
            }) 
        }); 
    }

    public CadastroLote(   dados: any ) : Promise<any> {  
        const head = { 'Authorization': this.getAxios().defaults.headers.common["Authorization"] }; 
        head["Content-Type"] = "multipart/form-data";  
        return  new Promise((resolve, reject) => {  
            this.getAxios().post( this.url + '/Lote'   , dados , { headers: head }   )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {   
                reject(error.response);
            }) 
        }); 
    }



    public getRh( cpf: any  ) : Promise<any>  { 
        return  new Promise((resolve, reject) => {  
            this.getAxios().get( this.url + '/Rh/' + cpf   )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {   
                reject(error.response);
            }) 
        }); 
    }


    public cadastrarViaRh( cpf: any  ) : Promise<any>  { 
        return  new Promise((resolve, reject) => {  
            this.getAxios().post( this.url + '/Rh/' + cpf  , {} )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {   
                reject(error.response);
            }) 
        }); 
    }


}
  
export default UsuarioService; 